<!-- eslint-disable max-len -->
<template>
  <div class="mt-3 space-y-1.5">
    <div
      v-for="(step, i) in steps"
      :key="step.key"
      class="flex items-center gap-2 text-sm font-medium transition-opacity"
      :class="rowState(i) === 'pending' ? 'text-white/50 opacity-60' : 'text-white opacity-100'"
    >
      <span class="flex size-4 shrink-0 items-center justify-center">
        <span
          v-if="rowState(i) === 'active'"
          class="size-3 animate-spin rounded-full border-2 border-white/30 border-t-white"
          aria-hidden="true"
        />
        <CheckIcon
          v-else-if="rowState(i) === 'done'"
          class="size-4 text-emerald-300"
          aria-hidden="true"
        />
      </span>
      <span>{{ step.label }}</span>
    </div>

    <div class="mt-2 h-1.5 max-w-md overflow-hidden rounded-full bg-white/20">
      <div
        class="h-full rounded-full bg-gradient-to-r from-teal-300 to-emerald-300 transition-[width] duration-500 ease-out"
        :style="{ width: `${livvia.processingProgress}%` }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { CheckIcon } from '@heroicons/vue/24/solid';
import useLivviaStore from '@/store/livvia';

const { t } = useI18n();
const livvia = useLivviaStore();

const steps = computed(() => [
  { key: 'read', label: t('livvia.processing.stepRead', { comments: livvia.lastLive?.commentsCount ?? 0 }) },
  { key: 'listen', label: t('livvia.processing.stepListen') },
  { key: 'build', label: t('livvia.processing.stepBuild') },
  { key: 'prepare', label: t('livvia.processing.stepPrepare') },
]);

// Row state = 'pending' | 'active' | 'done'
// processingStep counter: 0..steps.length. When counter > i, that step is done.
// When counter === i, it's active.
const rowState = (i: number): 'pending' | 'active' | 'done' => {
  const s = livvia.processingStep;
  if (s > i) return 'done';
  if (s === i) return 'active';
  return 'pending';
};
</script>
